import React from 'react';
import { CnDropdown, CnMenu, CnMenuItem } from '@cainiaofe/cn-ui';
import $i18n from '@alife/panda-i18n';
import './index.scss';
const User = ({ userName, handleLoginOut, isReverse, isCampus = false }) => {
    const userNode = (React.createElement("div", { className: "user-content" },
        React.createElement("span", null, userName),
        React.createElement("svg", { t: "1642585440250", className: "icon", viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "1741", width: "24", height: "24" },
            React.createElement("path", { d: "M512 648.533333l-192-192 29.866667-29.866666 162.133333 162.133333 162.133333-162.133333 29.866667 29.866666-192 192z", fill: isReverse ? '#000000' : '#ffffff', "p-id": "1742" }))));
    return userName ? (React.createElement(CnDropdown, { trigger: userNode, wrapperClassName: "user-dropdown-wrap" },
        React.createElement(CnMenu, null,
            React.createElement(CnMenuItem, { onClick: handleLoginOut }, $i18n.get({ id: 'LoginOut', dm: '退出' }))))) : (React.createElement("div", { className: "user-content", onClick: () => {
            location.href = `https://${location.host}/personal/${isCampus ? 'campus' : 'social'}-application`;
        } }, $i18n.get({ id: 'Login', dm: '登录' })));
};
export default User;
